import React, { useState, useEffect } from "react";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { getParentCompaniesAction } from "../../../actions/contactsAction";

export const General = (props) => {

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getParentCompaniesAction(props.companyData.contactTypeId));
  }, [props.companyData.contactTypeId]);

  const companyInfo = props.companyData;

  const businessInfo=props.businessData;
  const Gstate = useSelector((state) => state) || {};
  const ParentCompanies = Gstate?.Contacts.parentCompanies || [];
  const selectedCompany = ParentCompanies.find(company => company.CompanyId === companyInfo.parentCompanyId);
  const isSelectedbusiness=businessInfo.filter(item=>item.IsSelected); 
  const businessunit=isSelectedbusiness?.map(item => item.CompanyTypeName).join(',');
  return (
    <>
      <div id="contacts" className="mainContentData">
        <br></br>
        <div className="col-lg-12">
          <div className="col-lg-12 d-flex">
            <div className="col-lg-9">
              <div className="col-lg-12 row m-0 gap-5">
                {/* <div className="col-md-2">
                  <div className="mb-4">
                    <span className="fw-medium">Salutation</span>
                    <p className="fw-medium mb-0">{companyInfo.salutation || "-"}</p>
                  </div>
                </div> */}
                <div className="col-md-2">
                  <div className="mb-4">
                    <span className="fw-medium">Company</span>
                    <p className="fw-medium mb-0">{companyInfo.companyName || "-"}</p>
                  </div>
                </div>
                <div className="col-md-2">
                  <div className="mb-4">
                    <span className="fw-medium">is Parent Company</span>
                    <p className="fw-medium mb-0">
                    <input
                          type="checkbox"
                          checked={companyInfo.isParentCompany === true}
                        />
                    </p>
                  </div>
                </div>
                <div className="col-md-2">
                  <div className="mb-4">
                    <span className="fw-medium">Parent Company</span>
                    <p className="fw-medium mb-0">{selectedCompany?.CompanyName || "-"}</p>
                  </div>
                </div>
              </div>
              {companyInfo.contactTypeId === 2 ? (
              <div className="col-lg-11 px-0">
              <div className="mb-4">
                    <span className="fw-medium">Business Unit</span>
                    <p className="fw-medium mb-0">{    businessunit || "-"}</p>
                  </div>
          
                <hr />
              </div>
              ):null}
            </div>
          </div>
          <div className="col-lg-12 d-flex">
            <div className="col-lg-9">
              <div className="col-lg-12 row m-0 gap-5">
                <div className="col-md-2">
                  <div className="mb-4">
                    <span className="fw-medium">Phone 1</span>
                    <p className="fw-medium mb-0">{companyInfo.phone1 || "-"}</p>
                  </div>
                </div>
                <div className="col-md-2">
                  <div className="mb-4">
                    <span className="fw-medium">Phone 2</span>
                    <p className="fw-medium mb-0">{companyInfo.phone2 || "-"}</p>
                  </div>
                </div>
                <div className="col-md-2">
                  <div className="mb-4">
                    <span className="fw-medium">Fax Number</span>
                    <p className="fw-medium mb-0">{companyInfo.fax || "-"}</p>
                  </div>
                </div>
              </div>
              <div className="col-lg-12 row m-0 gap-5">
                <div className="col-md-2">
                  <div className="mb-4">
                    <span className="fw-medium">Email</span>
                    <p className="fw-medium mb-0">{companyInfo.email1 || "-"}</p>
                  </div>
                </div>
                <div className="col-md-2">
                  <div className="mb-4">
                    <span className="fw-medium">Email 2</span>
                    <p className="fw-medium mb-0">{companyInfo.email2 || "-"}</p>
                  </div>
                </div>
                <div className="col-md-2">
                  <div className="mb-4">
                    <span className="fw-medium">Email 3</span>
                    <p className="fw-medium mb-0">{companyInfo.email3 || "-"}</p>
                  </div>
                </div>
              </div>
              <div className="col-lg-11 px-0">
                <hr />
              </div>
              <div className="col-lg-12 row m-0 gap-5">
                <div className="col-md-2">
                  <div className="mb-4">
                    <span className="fw-medium">Year Founded</span>
                    <p className="fw-medium mb-0">{companyInfo.yearfounded || "-"}</p>
                  </div>
                </div>
                <div className="col-md-2">
                  <div className="mb-4">
                    <span className="fw-medium">Primary Contact</span>
                    <p className="fw-medium mb-0">{companyInfo.primarycontact || "-"}</p>
                  </div>
                </div>
                <div className="col-md-2">
                  <div className="mb-4">
                    <span className="fw-medium">Number of Employees</span>
                    <p className="fw-medium mb-0">{companyInfo.noofemployees || "-"}</p>
                  </div>
                </div>
                <div className="col-md-2">
                  <div className="mb-4">
                    <span className="fw-medium">Industry</span>
                    <p className="fw-medium mb-0">{companyInfo.industry || "-"}</p>
                  </div>
                </div>
              </div>
              <div className="col-lg-12 row m-0 gap-5">
                <div className="col-md-2">
                  <div className="mb-4">
                    <span className="fw-medium">Web URL</span>
                    <p className="fw-medium mb-0">{companyInfo.weburl || "-"}</p>
                  </div>
                </div>
                <div className="col-md-2">
                  <div className="mb-4">
                    <span className="fw-medium">LinkedIn URL</span>
                    <p className="fw-medium mb-0">{companyInfo.linkedurl || "-"}</p>
                  </div>
                </div>
                <div className="col-md-2">
                  <div className="mb-4">
                    <span className="fw-medium">Annual Revenue</span>
                    <p className="fw-medium mb-0">{companyInfo.annualrevenue || "-"}</p>
                  </div>
                </div>
                <div className="col-md-2">
                  <div className="mb-4">
                    <span className="fw-medium">Is Public</span>
                    <p className="fw-medium mb-0">
                    <input
                          type="checkbox"
                          checked={companyInfo.ispublic === true}
                        />
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-11 px-0">
                <hr />
              </div>
              <div className="col-lg-12 row m-0 gap-5">
                <div className="col-md-2">
                  <div className="mb-4">
                    <span className="fw-medium">Created By</span>
                    <p className="fw-medium mb-0">{companyInfo.createdBy || "-"}</p>
                  </div>
                </div>
                <div className="col-md-2">
                  <div className="mb-4">
                    <span className="fw-medium">Created Date</span>
                    <p className="fw-medium mb-0">{moment(companyInfo.createdDate).format("MM/DD/yyyy") || "-"}</p>
                  </div>
                </div>
                <div className="col-md-2">
                  <div className="mb-4">
                    <span className="fw-medium">Modified By</span>
                    <p className="fw-medium mb-0">{companyInfo.modifiedByUserName || "-"}</p>
                  </div>
                </div>
                <div className="col-md-2">
                  <div className="mb-4">
                    <span className="fw-medium">Modified Date</span>
                    <p className="fw-medium mb-0">{moment(companyInfo.modifiedDate).format("MM/DD/yyyy") || "-"}</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-3">
              <div className="col-lg-12">
                <div className="mb-4">
                  <span className="fw-medium">Notes</span>
                  <div
                    className="detail m-0 p-5"
                    style={{
                      height: "350px",
                      width: "40vh",
                      backgroundColor: "#eaf6ff",
                    }}
                  >
                    <p className="fw-medium mb-0">{companyInfo.notes || "-"}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
